import { NewsletterArchiveContent } from "./comunidad/NewsletterArchiveContent";

export const NewsletterArchiveTab = () => {
  return <NewsletterArchiveContent />;
};
